/*
 * --------------------------------------
 * Copyright (c) 2020 BetterCapital.US
 * --------------------------------------
 */
import { put, call, takeEvery } from "redux-saga/effects";
import { CMSContent } from "../api/agent";
import {
  GET_RECOMMENDATIONS,
  GET_RECOMMENDATIONS_FAILURE,
  GET_RECOMMENDATIONS_SUCCESS,
} from "../actions/actionTypes";

function* getRecommendations(action) {
  try {
    const payload = yield call(CMSContent.getRecommendations, action.payload);
    yield put({ type: GET_RECOMMENDATIONS_SUCCESS, payload });
  } catch (err) {
    const errResp = err.response.body;
    yield put({ type: GET_RECOMMENDATIONS_FAILURE, errResp });
  }
}

export function* watchGetRecommendations() {
  yield takeEvery(GET_RECOMMENDATIONS, getRecommendations);
}
